import Vue from 'vue';

const params = new URLSearchParams(window.location.search)

const state = {
    pointOfSale: {},
    pointOfSales: [],
    pdv_id: params.get('pdv'),
};

const actions = {
    showPointOfSales: (context) => {
        return new Promise((resolve, reject) => {
            axios.get(`/api/point-of-sales`).then(response => {
                context.commit('SHOW_POINT_OF_SALES', response.data)
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    showPointOfSale: (context, id) => {
        return new Promise((resolve, reject) => {
            axios.get(`/api/point-of-sales/${id}`).then(response => {
                context.commit('SHOW_POINT_OF_SALE', response.data)
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    storePointOfSale: (context, payload) => {
        return new Promise((resolve, reject) => {
            axios.post(`/api/point-of-sales`, payload).then(response => {
                context.commit('STORE_POINT_OF_SALE', response.data)
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    updatePointOfSale: (context, payload) => {
        return new Promise((resolve, reject) => {
            axios.put(`/api/point-of-sales/${payload.id}`, payload).then(response => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    destroyPointOfSale: (context, id) => {
        return new Promise((resolve, reject) => {
            axios.delete(`/api/point-of-sales/${id}`).then(response => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    setPdvId: (context, id) => {
        context.commit('SET_PDV_ID', id);
        // Chama showPointOfSale automaticamente ao setar o pdv_id
        return context.dispatch('showPointOfSale', id);
    },
};

const mutations = {
    SHOW_POINT_OF_SALE: (state, payload) => {
        state.pointOfSale = payload
    },
    SHOW_POINT_OF_SALES: (state, payload) => {
        state.pointOfSales = payload
    },
    STORE_POINT_OF_SALE: (state, payload) => {
        state.pointOfSale = payload
    },
    SET_PDV_ID: (state, id) => {
        state.pdv_id = id;
    },
};

const getters = {
    pointOfSale: state => {
        return state.pointOfSale
    },
    pointOfSales: state => {
        return state.pointOfSales
    },
    pdvId: state => {
        return state.pdv_id
    },
    pdv_id: state => state.pdv_id
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}
